import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { groupBySection } from "../../lib/planner";

const SECTION = { office: "Office 365", ems: "Enterprise Mobility + Security", windows: "Windows", suite: "Suite", related: "Add-ons & related" };

export default function FeatureDiff({ gains, losses, testid = "feature-diff" }) {
  const [open, setOpen] = useState(false);
  if (!gains.length && !losses.length) return null;
  const render = (list, cls) =>
    Object.entries(groupBySection(list)).map(([sec, items]) => (
      <div key={sec} className="fd-section">
        <h5>
          {SECTION[sec] || sec} <span className="mono">{items.length}</span>
        </h5>
        <ul>
          {items.map((r) => (
            <li key={r.id} className={cls} style={{ paddingLeft: 8 + (r.indent || 0) * 10 }}>
              {r.name}
            </li>
          ))}
        </ul>
      </div>
    ));
  return (
    <div className="feature-diff" data-testid={testid}>
      <button type="button" className="fd-toggle" onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid={`${testid}-toggle`}>
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        <span className="mini-chip ok">+{gains.length} features gained</span>
        {losses.length > 0 && <span className="mini-chip warn">-{losses.length} lost</span>}
        <span className="muted">{open ? "hide" : "show"} details</span>
      </button>
      {open && (
        <div className="fd-body">
          {gains.length > 0 && (
            <div className="fd-col">
              <h4 className="ok">Gained</h4>
              {render(gains, "gain")}
            </div>
          )}
          {losses.length > 0 && (
            <div className="fd-col">
              <h4 className="warn">Lost</h4>
              {render(losses, "loss")}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
